import QLogo from "../../assets/images/q-logo.svg";

const Logo = ({ size = 24 }: { size?: number }) => (
  <img src={QLogo} alt="MEQ Insights" width={size} height={size} />
);

export default Logo;
